import React, { useState, useEffect, useRef } from 'react';

function FoodSearchBar({ onSearch, autoFocus }) {
  const [query, setQuery] = useState('');
  const inputRef = useRef(null);

  // Debounce search
  useEffect(() => {
    if (!query.trim()) {
      onSearch('');
      return;
    }

    const timer = setTimeout(() => {
      onSearch(query.trim());
    }, 300);

    return () => clearTimeout(timer);
  }, [query, onSearch]);

  // Auto-focus on mount
  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  const handleClear = () => {
    setQuery('');
    inputRef.current?.focus();
  };

  return (
    <div className="search-bar">
      <span className="search-bar-icon">{'\u2315'}</span>
      <input
        ref={inputRef}
        type="text"
        className="search-bar-input"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search foods..."
        autoComplete="off"
        autoCorrect="off"
        spellCheck="false"
      />
      {query && (
        <button className="search-bar-clear" onClick={handleClear} type="button">
          {'\u00D7'}
        </button>
      )}
    </div>
  );
}

export default FoodSearchBar;
